import { useState } from 'react';
import { extractErrorMessage } from '../utils/error.utils';
import axios from 'axios';
import { GET_RENT, WEB_RENT } from '../config/api';
import { useDispatch, useSelector } from 'react-redux';
import { authActions, getAuthToken } from '../store';
import { toast } from 'react-toastify';
import { ExternalAuthenticationResult } from './useSafe2Pay3DS';

interface CreateRentPayload {
    device_id: string;
    cardholder_name: string;
    card_brand: string;
    card_number: string;
    card_expire_date: string;
    card_security_number: string;
    cardholder_document: string;
    external_authentication: ExternalAuthenticationResult;
}

const useRents = () => {
    const [isLoading, setIsLoading] = useState(false);
    const access_token = useSelector(getAuthToken);

    const dispatch = useDispatch();

    const webRent = async (payload: CreateRentPayload) => {
        setIsLoading(true);

        try {
            const result = await axios.post(WEB_RENT, payload);
            const response = result?.data;

            dispatch(
                authActions.login({
                    user: response.client.user,
                    client: response.client,
                    access_token: response.access_token,
                }),
            );

            console.log('rent successfully started:', response.rent.id);

            return response;
        } catch (err: any) {
            toast.error(extractErrorMessage(err), { toastId: 'error', autoClose: false });
        } finally {
            setIsLoading(false);
        }
    };

    const fetchRent = async (id: string) => {
        if (!access_token) return;
        setIsLoading(true);

        try {
            const result = await axios.get(GET_RENT(id), {
                headers: { Authorization: `Bearer ${access_token}` },
            });
            if (result.data.status !== 'ACTIVE' && result.data.status_message) {
                toast.error(result.data.status_message, { toastId: 'error', autoClose: false });
            }
            return result?.data;
        } catch (err: any) {
            toast.error(extractErrorMessage(err), { toastId: 'error', autoClose: false });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        fetchRent,
        webRent,
        isLoading,
    };
};

export default useRents;
